/**
 * # Privacy Page
 */

/**
 * ## Imports
 */
import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import clsx from 'clsx';
import { ClientName } from 'client/clientConfig';

import PageFooter from 'common/components/PageFooter/PageFooter';
import PageHeader from 'common/components/PageHeader/PageHeader';
import CopyText from 'common/components/CopyText';
import useScrollToHash from 'hooks/useScrollToHash';
import GetPrivacyContent from './utils/GetPrivacyContent';
import { submitMetrics } from '../../lib/submitMetrcis';
import { queryStringToObject } from '../../lib/query';
import GetAdblockPrivacyContent from './utils/GetAdblockPrivacyContent';

/**
 * ## Component
 */
const PrivacyPolicyPage = () => {
    const isSonicClient = ClientName === 'sonic';
    const isAdblockClient = ClientName === 'adblock';
    const location = useLocation();
    const appClassName = `app ${ClientName ? `app--${ClientName}` : ''}`;
    const content = isAdblockClient ? GetAdblockPrivacyContent() : GetPrivacyContent();
    useScrollToHash();

    useEffect(() => {
        submitMetrics({
            Category: 'BrowserLandingPage',
            Action: 'view',
            Object: 'webpage',
            ReferalSource: queryStringToObject(location?.search || ''),
        });
    });

    return (
        <div className={appClassName}>
            {(isSonicClient || isAdblockClient) && (
                <PageHeader clientName={ClientName} />
            )}
            <div className={clsx('follows-pageheader framed-section framed-section--less-margin-bottom', {
                'framed-section--adblock': isAdblockClient,
            })}
            >
                <div className="centerwrapper centerwrapper--very-narrow">
                    <h1 className="headline-main">Privacy Policy</h1>
                    {isSonicClient && <h3 className="headline-exception-sextary">This Policy was last updated on June 12, 2024</h3>}
                </div>
            </div>
            <CopyText clientName={ClientName}>{content}</CopyText>
            <PageFooter clientName={ClientName} />
        </div>
    );
};

export default PrivacyPolicyPage;
